import React from 'react'
import clsx from 'clsx'

import { formatTimeStamp } from '../../../../../../utilities'
import { withinTimeInterval, formatDate } from '../../../../../../timeUtilities'
import useStyles from '../styles'

export const TooltipDetails = ({ time, user }) => {
  const classes = useStyles()
  return (
    <div key={time}>
      {user ? (
        <div className={classes.container}>
          <div className={classes.name}>{user}</div>
          <div>
            <span className={classes.label}>Last seen:</span>
            <span className={classes.toolTipTime}>
              {' '}
              {time ?? formatTimeStamp(time)}
            </span>
          </div>
        </div>
      ) : (
        <>
          <span className={classes.label}>Last seen:</span>
          <span className={classes.time}> {time ?? formatTimeStamp(time)}</span>
        </>
      )}
    </div>
  )
}

export const LoggedIn = ({ name, keyId, online }) => {
  const classes = useStyles({ online: online })
  return (
    <div className={classes.container} key={keyId}>
      <div className={classes.name}>{name}</div>
      <div>
        <span className={classes.label}>Last seen:</span>
        <span className={clsx(classes.toolTipTime, online && classes.online)}>
          {' '}
          {online === 'online'
            ? 'Online'
            : online === 'away'
            ? 'Away'
            : 'Never'}
        </span>
      </div>
    </div>
  )
}

export const getTooltipInfo = (allUsers, ids, presence) => {
  if (!allUsers) {
    return
  }

  let names = []
  let formatted

  ids.forEach(id => {
    names.push({
      id: id,
      online: allUsers[id]?.online_status?.last_seen ?? null
    })
  })

  return (
    <>
      {names.map(n => {
        const { id, online } = n
        if (!online) {
          return <LoggedIn name={allUsers[id]?.name} key={id} />
        }

        if (
          presence[id] &&
          (presence[id] === 'online' || presence[id] === 'away')
        ) {
          return (
            <LoggedIn
              name={allUsers[id]?.name}
              key={id}
              online={presence[id]}
            />
          )
        }

        const newDate = withinTimeInterval(online)

        switch (newDate) {
          case 0:
            formatted = formatTimeStamp(online)
            break
          case 1:
            formatted = formatDate(online, 'EEE, h:mm aaa')
            break
          case 2:
            formatted = formatDate(online, 'd MMM, h:mm aaa')
            break
          case 3:
            formatted = formatDate(online, 'd MMM, yyyy')
            break

          default:
            formatted = formatTimeStamp(online)
        }
        return (
          <TooltipDetails time={formatted} user={allUsers[id]?.name} key={id} />
        )
      })}
    </>
  )
}
